import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConicalIcon, MapIcon, LeafIcon } from 'lucide-react';
export function UniqueMechanism() {
  const steps = [{
    icon: FlaskConicalIcon,
    title: 'PASO 1 — Eliminás la huella química',
    description: 'Destruís la molécula de ácido úrico con enzimas específicas. El faro invisible deja de existir para su olfato.'
  }, {
    icon: MapIcon,
    title: 'PASO 2 — Re-mapeás el territorio',
    description: 'Reubicás las bandejas con el sistema N+1. Su cerebro registra la caja como el único punto lógico de marcaje.'
  }, {
    icon: LeafIcon,
    title: 'PASO 3 — Neutralizás el disparador',
    description: 'Identificás qué elemento de tu hogar genera el estrés que activa la conducta. Lo desactivás con las feromonas de tu propio gato.'
  }];
  return <section className="w-full bg-[#2D8C5A] py-6 md:py-20 px-4 md:px-6" data-id="element-386">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-387">
        <div className="text-center mb-8 md:mb-12" data-id="element-388">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-389">
            El Protocolo de Re-seteo de Territorio™
          </h2>
          <p className="text-xl text-white/90 leading-relaxed" data-id="element-390">
            No es un manual de entrenamiento, es una intervención biológica. En
            lugar de pelear contra el instinto de tu gato, usamos la etología
            felina para hackear sus señales de propiedad. Eliminamos la "huella
            química" con enzimas y re-mapeamos tu hogar para que la bandeja sea,
            por instinto, el único lugar lógico para su cerebro.
          </p>
        </div>

        <div className="space-y-4 md:space-y-6 mb-6 md:mb-10" data-id="element-391">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 border border-white/20" data-id="element-392">
                <div className="flex items-start gap-4" data-id="element-393">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center" data-id="element-394">
                    <Icon className="w-6 h-6 text-white" data-id="element-395" />
                  </div>
                  <div data-id="element-396">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-397">
                      {step.title}
                    </h3>
                    <p className="text-white/90 leading-relaxed" data-id="element-398">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center text-lg md:text-xl text-white/95 italic border-l-4 border-white/40 pl-6 py-4" data-id="element-399">
          "El resultado no es que tu gato aprenda a portarse bien. Es que su
          cerebro deja de tener razones para marcar fuera de la caja."
        </motion.blockquote>
      </motion.div>
    </section>;
}